import { createAction, props } from '@ngrx/store';

export const loadAgreements = createAction(
  '[Agreement] Load Agreements',
  props<{ langCode: string, insurerId: string, profileId: number }>()
);

export const loadAgreementsSucess = createAction(
  '[Agreement] Load Agreements Success',
  props<{ data: string }>()
);

export const loadAgreementFailure = createAction(
  '[Agreement] Load Agreements Failure',
  props<{ error: any }>()
);

export const resetAgreement = createAction("[Agreement] Reset");